<template>
	<div class="connect_bg">
		<div class="connect_wrap">
			<div class="connect_close_btn" @click="close"></div>
			<div class="connecting_wrap">
				<div class="connecting_icon connecting_icon_failed"></div>
				<div class="connecting_title">连接失败</div>
				<div class="connecting_tips">失败原因：华为路由器访问限制</div>
				<div class="connecting_tips">建议使用代理模式重试</div>
				<div class="connecting_btns">
					<div class="connecting_btn cancel_btn" @click="close">
						取消
					</div>
					<div class="connecting_btn" @click="reTry">
						使用代理模式重试
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {};
	},
	props: ["isFailed", "name", "connectRet"],
	methods: {
		close: function () {
			let _that = this;
			_that.$emit("close");
		},
		reTry: function () {
			let _that = this;
			_that.$emit("reTry");
		},
	},
	mounted() {
		let _that = this;
	},
};
</script>

<style lang="less" scoped>
.connect_bg {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 9;
	.connect_wrap {
		width: 460px;
		height: 320px;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-top: -160px;
		margin-left: -230px;
		background-color: #f5f5f5;
		border-radius: 5px;

		.connect_close_btn {
			width: 20px;
			height: 20px;
			position: absolute;
			right: 20px;
			top: 14px;
			cursor: pointer;
			background-image: url(../../assets/common/close2.svg);
			background-size: 100% 100%;
		}
		.connecting_icon {
			width: 203px;
			height: 133px;
			background-image: url(../../assets/home/node/connecting_icon.svg);
			background-size: 100% auto;
			margin: 50px auto 18px auto;
		}
		.connecting_icon_failed {
			background-image: url(../../assets/home/node/connect_failed_icon.svg);
		}
		.connecting_title {
			font-size: 14px;
			color: #666666;
			font-weight: bolder;
			text-align: center;
		}
		.connecting_name {
			color: #666666;
			font-size: 12px;
			text-align: center;
			margin-top: 5px;
		}
		.connecting_tips {
			color: #666666;
			font-size: 12px;
			text-align: center;
			margin-top: 3px;
			span {
				color: #1f5de3;
				margin-left: 5px;
				cursor: pointer;
			}
		}
		.connecting_btns {
			text-align: center;
		}
		.connecting_btn.cancel_btn {
			background-color: #e1e1e1;
			color: #666666;
			margin-right: 20px;
			width: 88px;
		}
		.connecting_btn {
			font-size: 12px;
			display: inline-block;
			vertical-align: top;
			width: 118px;
			height: 36px;
			line-height: 36px;
			text-align: center;
			color: #ffffff;
			background-color: #1f5de3;
			border-radius: 18px;
			margin: 0 auto;
			margin-top: 10px;
		}
		.connecting_btn:hover {
			cursor: pointer;
			opacity: 0.8;
		}
	}
}
</style>